<template>
<BootstrapDialog title="试题预览" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
			<div class="tm_main" style="margin: 0px 0px;">
			    <div class="tm_container">
			        <table width="100%" cellpadding="5" border="0" class="tm_table_form">
			            <tbody>
			            <tr>
			                <th width="120" nowrap="nowrap">试题类别：</th>
			                <td width="40%" v-html="stlbName"></td>
			                <th width="120">题型名称：</th>
			                <td v-html="model.tx"></td>
			            </tr>
			            <tr v-if="model.tkmc">
			                <th width="120" nowrap="nowrap">所属题库：</th>
			                <td width="40%" v-html="model.tkmc"></td>
			                <th width="120">试题来源：</th>
			                <td v-html="model.stly"></td>
			            </tr>
			            <tr>
			                <th nowrap="nowrap">试题状态：</th>
			                <td v-html="model.zt=='OK'?'开放':'关闭'"></td>
			                <th nowrap="nowrap">试题难度：</th>
			                <td v-html="model.stnd=='FCRY'?'非常容易':
			                    model.stnd=='BJRY'?'比较容易':
			                    model.stnd=='CG'?'常规':
			                    model.stnd=='JN'?'较难':'非常难'"></td>
			
			            </tr>
			            <tr>
			                <th nowrap="nowrap">试题题干：</th>
			                <td colspan="3" v-html="model.sttg"></td>
			            </tr>
			            <tr id="suite" v-if="model.stlb != 'TT'">
			                <th nowrap="nowrap" id="tm_title">答案设置：</th>
			                <td colspan="3" v-if="model.stlb=='JUDGMENT'" v-html="model.stda=='Y'?'正确':'错误'"></td>
			                <td colspan="3" v-if="model.stlb!='JUDGMENT'" v-html="model.stda"></td>
			            </tr>
			            <tr>
			                <th nowrap="nowrap" >试题解析：</th>
			                <td colspan="3" id="">
			                    <div v-html="model.stjx"></div>
			                </td>
			            </tr>
			            </tbody>
			        </table>
			        <div style="border: 1px solid #DDDDDD;;margin: 10px" v-if="childrens!=null &&childrens!=undefined && childrens.length>0">
			            <!--小题区域-->
			            <template v-for="(question,ques_index) in childrens">
			                <!--小题模板 单选题-->
			                <div class="ks_coon_date" v-if="question.stlb=='SINGLECHOICE'"
			                     :key="question.stlb.toLowerCase()+'_question_'+ques_index"
			                     :id="question.stlb.toLowerCase()+'_question_'+ques_index">
			                    <!--小题题干-->
			                    <table>
			                        <tbody>
			                        <tr>
			                            <td>
			                                <h6>
			                                    <span>{{ques_index+1}}</span>
			                                </h6>
			                            </td>
			                            <td>
			                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--单选题选项-->
			                    <table class="optTbl">
			                        <tbody>
			                        <tr v-for="(option,qps_index) in question.options"
			                            :key="question.stlb.toLowerCase()+'_option_'+qps_index">
			                            <td class="td1" valign="bottom">
			                                <label v-html="option.alisa+'.'" style="margin-left: 5px"></label>
			                            </td>
			                            <td valign="bottom">
			                                <label v-html="option.text || ''"></label>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--正确答案与解析-->
			                    <div class="div-key-container" style="padding-left:20px">
			                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                        <span style="color: #417ac1;" v-html="question.stda"></span>
			                    </div>
			                    <div class="div-key-container" style="padding-left: 20px">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
			                        <span style="color: #2a8801;" v-html="question.stjx"></span>
			                    </div>
			                </div>
			                <!--结束-->
			
			                <!--小题模板 多选题-->
			                <div class="ks_coon_date" v-if="question.stlb=='MULTIPLECHOICE'"
			                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                    <!--小题题干-->
			                    <table>
			                        <tbody>
			                        <tr>
			                            <td>
			                                <h6>
			                                    <span>{{ques_index+1}}</span>
			                                </h6>
			                            </td>
			                            <td>
			                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--多选题选项-->
			                    <table class="optTbl">
			                        <tbody>
			                        <tr v-for="(option,qps_index) in question.options"
			                            :key="question.stlb.toLowerCase()+'_option_'+qps_index">
			                            <td class="td1" valign="bottom"><label v-html="option.alisa+'.'" style="margin-left: 5px"></label></td>
			                            <td valign="bottom">
			                                <label v-html="option.text || ''"></label>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--正确答案与解析-->
			                    <div class="div-key-container" style="padding-left:20px">
			                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                        <span style="color: #417ac1;" v-html="question.stda"></span>
			                    </div>
			                    <div class="div-key-container" style="padding-left: 20px">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
									 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                    </div>
			                </div>
			                <!--结束-->
			
			                <!--小题模板 判断题-->
			                <div class="ks_coon_date" v-if="question.stlb=='JUDGMENT'"
			                     :key="question.stlb.toLowerCase()+'_question_'+ques_index"
			                     :id="question.stlb.toLowerCase()+'_question_'+ques_index">
			                    <!--小题题干-->
			                    <table>
			                        <tbody>
			                        <tr>
			                            <td>
			                                <h6>
			                                    <span>{{ques_index+1}}</span>
			                                </h6>
			                            </td>
			                            <td>
			                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--正确答案与解析-->
			                    <div class="div-key-container" style="padding-left:20px">
			                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                        <span style="color: #417ac1;" v-html="question.stda ? (question.stda =='Y'?'正确':'错误') : ''"></span>
			                    </div>
			                    <div class="div-key-container" style="padding-left: 20px">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
									 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                    </div>
			                </div>
			                <!--结束-->
			
			                <!--小题模板 填空题-->
			                <div class="ks_coon_date" v-if="question.stlb=='BLANKFILL'"
			                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                    <!--小题题干-->
			                    <table>
			                        <tbody>
			                        <tr>
			                            <td>
			                                <h6>
			                                    <span>{{ques_index+1}}</span>
			                                </h6>
			                            </td>
			                            <td>
			                                <p class="ks_coon_dates" v-html="question.displaySttg || ''"></p>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--正确答案与解析-->
			                    <div class="div-key-container" style="padding-left:20px">
			                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                        <span style="color: #417ac1;" v-html="question.stda "></span>
			                    </div>
			                    <div class="div-key-container" style="padding-left: 20px">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
									 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                    </div>
			                </div>
			                <!--结束-->
			
			                <!--小题模板 问答题-->
			                <div class="ks_coon_date"
			                     v-if="question.stlb=='ESSAY' || question.stlb=='MCJST' || question.stlb=='LST' || question.stlb=='JDT'"
			                     :id="question.stlb.toLowerCase()+'_question_'+ques_index"
			                     :key="question.stlb.toLowerCase()+'_question_'+ques_index">
			                    <!--小题题干-->
			                    <table>
			                        <tbody>
			                        <tr>
			                            <td>
			                                <h6>
			                                    <span>{{ques_index+1}}</span>
			                                </h6>
			
			                            </td>
			                            <td>
			                                <p class="ks_coon_dates" v-html="question.sttg || ''"></p>
			                            </td>
			                        </tr>
			                        </tbody>
			                    </table>
			                    <!--正确答案与解析-->
			                    <div class="div-key-container" style="padding-left:20px">
			                        <span style="margin-right: 5px;color: #417ac1;">标准答案：</span>
			                        <span style="color: #417ac1;" v-html="question.stda"></span>
			                    </div>
			                    <div class="div-key-container" style="padding-left: 20px">
			                        <span style="margin-right: 5px;color: #2a8801;">试题解析：</span>
									 <span style="color: #2a8801;" v-html="question.stjx"></span>
			                    </div>
			                </div>
			                <!--结束-->
			            </template>
			        </div>
			    </div>
			</div>
		</div>
	</template>
	<template v-slot:footer>
		<button class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>	
</template>
<script>

    /**
     * 管理试题通用题
     */
    export default {
        name:'QuesDetailTongYt',
		components:{
		},
        data:function(){
            return {
                stlbList:[],
                stdata:{},
                stlb:'',
                stlbName:'',
                model:{
					id:'',
                    stlb:'',
                    tx:'',
                    tk_id:'',
                    stly:'',
                    zt:'',
                    stnd:'',
                    sttg:'',
                    stda:'',
                    stjx:''
                },
                childrens:[]
            }
        },
        methods:{
			reset:function(){
				this.stlbList = [];
				this.stdata = {};
				this.stlb = '';
				this.stlbName = '';
				this.model = {
					id:'',
					stlb:'',
					tx:'',
					tk_id:'',
					stly:'',
					zt:'',
					stnd:'',
					sttg:'',
					stda:'',
					stjx:''
				},
				this.childrens = [];
			},
			async open(params){
				this.stlb = params.stlb;
				this.model.id = params.id;
				if(this.model.id){
					let res = await this.$http.post('/htgl/zktk/st/hq',{id:this.model.id});
					if(res.data){
						this.model = res.data.zktkSt || {};
						if(this.model.stlb == 'TT'){
							this.childrens = res.data.childrens || [];
							this.childrens.forEach(item => {
								if(item.stjx){
									item.stjx = item.stjx.replace('<p>','').replace('</p>','')
								}
						        if (item.stlb == 'BLANKFILL') {
						            let regExp = /(\[BlankArea(\d+)\])+/g;
						            let blankInput = '_____';
						            let a = item.sttg.replace(regExp, blankInput);
						            item.displaySttg = a || item.sttg;
						        }
						    });
						}
					}
				}
				this.stlbList = [{value: 'SINGLECHOICE', text: '单选题'}, {value: 'MULTIPLECHOICE', text: '多选题'}, {value: 'JUDGMENT', text: '判断题'}, {value: 'BLANKFILL', text: '填空题'}, {value: 'ESSAY', text: '问答题'}, {value: 'MCJST', text: '名词解释题'}, {value: 'LST', text: '论述题'}, {value: 'JDT', text: '简答题'}, {value: 'TT', text: '套题'}];//试题类别
				let list = this.stlbList.filter(x=>x.value == this.stlb);
				this.stlbName = list&&list.length>0 ?  list[0].text : '';
				this.$nextTick(()=>{
					this.$refs.dialog.open();
				});
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			}
        }

    }
</script>
<style scoped>
    .tm_main{
        margin: 10px 10px;
        width: 100%;
    }
    .tm_table_form tbody p {
        margin: 10px 10px;
    }
    .tm_table_form tbody tr th {
        text-align: right;
        font-size: 16px;
        border: solid 1px #eee;
        background: #f5f5f5;
        line-height: 20px;
        font-weight:800;
        padding: 12px;
    }
    .tm_table_form tr td {
        border: solid 1px #eee;
        padding: 12px;
        text-align: left;
        border: solid 1px #eee !important;
        background: #fff !important;

    }
    .ks_coon_date table tbody tr td h6 span {
        display: inline-block;
        vertical-align: top;
        color: #FFFFFF;
        background-color: #2EB3E5;
        width: 24px;
        height: 24px;
        margin-right: 5px;
        text-align: center;
        line-height: 24px;
        margin-left: 12px;
        margin-top: 7px;
        border-radius: 12%;
    }
    .ks_coon_date table tbody tr td h6 p.ys {
        display: inline-block;
        vertical-align: top;
        /*color: black;*/
        /*background-color: #d1f3e5;*/
        width: 24px;
        height: 24px;
        margin-right: 5px;
        text-align: center;
        line-height: 24px;
        margin-left: 12px;
        margin-top: 7px;
        border-radius: 50%;
        font-size: 15px;
    }
    
    * {
        margin: 0;
        list-style: none;
        text-decoration: none;
    }

    .ks_coon_date {
        width: 95%;
        margin: 0 auto;
        margin-top: 10px;
        border: 1px solid #E4E4E4;
        margin-bottom: 10px;
    }

    .ks_coon_date .ks_coon_dates {
        padding: 10px 0 0 5px;
        color: #666;;
    }

    .ks_coon_date table tbody tr td h6 p.ys {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        margin-right: 5px;
        text-align: center;
        line-height: 24px;
        margin-left: 12px;
        margin-top: 7px;
        border-radius: 50%;
        font-size: 15px;
    }

    .ks_coon_date td {
        vertical-align: top;
    }

    .optTbl .td1 {
        width: 55px;
        text-align: right;
    }
    
    label {
        font-weight: 400;
    }

</style>